export const MISSING_VOICES_DOMAIN = "missingvoices.app";
export const TEACH_LEAGUE_DOMAIN = "teachleague.com";
export const MISSING_VOICES_PATH = "/missingvoices";
export const LEGACY_MISSING_VOICES_PATH = "/missing-voices";

const LOCALHOST_HOSTS = new Set(["localhost", "127.0.0.1", "::1", "[::1]"]);
const MISSING_VOICES_HOSTS = new Set([
  MISSING_VOICES_DOMAIN,
  `www.${MISSING_VOICES_DOMAIN}`,
]);
const TEACH_LEAGUE_HOSTS = new Set([
  TEACH_LEAGUE_DOMAIN,
  `www.${TEACH_LEAGUE_DOMAIN}`,
]);

export const normalizeAppPath = (pathname = "/") => {
  const rawPath = typeof pathname === "string" ? pathname.trim() : "";
  if (!rawPath || rawPath === "/") return "/";

  const withLeadingSlash = rawPath.startsWith("/")
    ? rawPath
    : `/${rawPath}`;

  return withLeadingSlash.length > 1 && withLeadingSlash.endsWith("/")
    ? withLeadingSlash.slice(0, -1)
    : withLeadingSlash;
};

export const isLocalDevelopmentHost = (hostname = "") =>
  LOCALHOST_HOSTS.has(String(hostname || "").toLowerCase());

export const isMissingVoicesHost = (hostname = "") =>
  MISSING_VOICES_HOSTS.has(String(hostname || "").toLowerCase());

export const isTeachLeagueHost = (hostname = "") =>
  TEACH_LEAGUE_HOSTS.has(String(hostname || "").toLowerCase());

export const isMissingVoicesSurfacePath = (pathname = "", hostname = "") => {
  const normalizedPath = normalizeAppPath(pathname);

  return (
    (isMissingVoicesHost(hostname) && normalizedPath === "/") ||
    normalizedPath === MISSING_VOICES_PATH ||
    normalizedPath.startsWith(`${MISSING_VOICES_PATH}/`) ||
    normalizedPath === LEGACY_MISSING_VOICES_PATH ||
    normalizedPath.startsWith(`${LEGACY_MISSING_VOICES_PATH}/`)
  );
};

export const getMissingVoicesUrl = (pathname = MISSING_VOICES_PATH) =>
  `https://${MISSING_VOICES_DOMAIN}${normalizeAppPath(pathname)}`;

export const getTeachLeagueUrl = (pathname = "/") =>
  `https://${TEACH_LEAGUE_DOMAIN}${normalizeAppPath(pathname)}`;

export const getMissingVoicesSurfaceDestination = (hostname = "") => {
  if (isLocalDevelopmentHost(hostname)) {
    return {
      type: "internal",
      href: MISSING_VOICES_PATH,
    };
  }

  if (isMissingVoicesHost(hostname)) {
    return {
      type: "internal",
      href: "/",
    };
  }

  return {
    type: "external",
    href: getMissingVoicesUrl(MISSING_VOICES_PATH),
  };
};

export const getTeachLeagueSurfaceDestination = (
  pathname = "/",
  hostname = ""
) => {
  const normalizedPath = normalizeAppPath(pathname);

  if (isLocalDevelopmentHost(hostname) || isTeachLeagueHost(hostname) || !hostname) {
    return {
      type: "internal",
      href: normalizedPath,
    };
  }

  if (isMissingVoicesHost(hostname)) {
    return {
      type: "external",
      href: getTeachLeagueUrl(normalizedPath),
    };
  }

  return {
    type: "internal",
    href: normalizedPath,
  };
};
